// extracted by mini-css-extract-plugin
module.exports = {"barcode":"Barcode_barcode__1YJTX","barcodeTitle":"Barcode_barcodeTitle__3xnfT"};